import { render, staticRenderFns } from "./PlayerSeasonPoint.vue?vue&type=template&id=06bd7860&scoped=true&"
import script from "./PlayerSeasonPoint.vue?vue&type=script&lang=js&"
export * from "./PlayerSeasonPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd7860",
  null
  
)

export default component.exports